import React from "react";
import "../index.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <small>© 2025 Safo Oppong • Kyekyeku-Tech</small>
      </div>
    </footer>
  );
};

export default Footer;
